import { render, staticRenderFns } from "./lhkDeclare.vue?vue&type=template&id=823cecae&scoped=true&"
import script from "./lhkDeclare.vue?vue&type=script&lang=js&"
export * from "./lhkDeclare.vue?vue&type=script&lang=js&"
import style0 from "./lhkDeclare.vue?vue&type=style&index=0&id=823cecae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823cecae",
  null
  
)

export default component.exports